document.addEventListener('DOMContentLoaded', function() {
    const expandedStates = new Map();

    function measureHiddenHeight(el, width) {
        const clone = el.cloneNode(true);
        Object.assign(clone.style, {
            position: 'absolute',
            visibility: 'hidden',
            pointerEvents: 'none',
            height: 'auto',
            maxHeight: 'none',
            left: '-9999px',
            width: width ? width + 'px' : getComputedStyle(el).width,
        });
        document.body.appendChild(clone);
        const h = clone.scrollHeight;
        document.body.removeChild(clone);
        return h;
    }

    /**
     * Forces the immediate parent of the content (custom__tab-text) to recalculate its height.
     * This addresses the issue of content being cut off by the section below.
     */
    function forceTabContainerResize(tabContentElement) {
        if (!tabContentElement) return;

        // Ensure the container allows flow, then force a reflow before returning to default
        tabContentElement.style.height = 'auto';
        tabContentElement.offsetHeight; // Force reflow/re-render
        tabContentElement.style.height = '';
    }

    /**
     * Recalculates collapsed height and applies max-height based on expandedStates.
     */
    function setCollapsedHeight(container) {
        const wrapper = container.querySelector('.read-more-wrapper');
        const content = container.querySelector('.read-more-content');
        const btn = container.querySelector('.read-more-toggle');
        if (!wrapper || !content || !btn) return;

        const cs = window.getComputedStyle(content);
        let lineHeight = parseFloat(cs.lineHeight);
        if (isNaN(lineHeight)) {
            const fontSize = parseFloat(cs.fontSize) || 16;
            lineHeight = fontSize * 1.2;
        }

        const lines = parseInt(container.getAttribute('data-lines'), 10) || 3;
        const collapsedH = Math.ceil(lineHeight * lines);
        wrapper.dataset.collapsedHeight = collapsedH;

        const tabId = container.closest('[data-tab-id]').dataset.tabId;
        const key = container.id || tabId || Math.random();
        const isExpanded = !!expandedStates.get(key);

        if (expandedStates.get(key) === undefined) {
            expandedStates.set(key, false);
        }

        let fullHeight = content.scrollHeight;
        if (!fullHeight || fullHeight < 1) {
            fullHeight = measureHiddenHeight(content, wrapper.clientWidth);
        }

        if (isExpanded) {
            wrapper.style.maxHeight = 'none';
            wrapper.classList.add('is-expanded');
            btn.textContent = 'Show Less';
            btn.setAttribute('aria-expanded', 'true');

            // When setting initial state to expanded (e.g., on tab switch), force parent resize
            const tabContent = container.closest('.custom__tab-text');
            if (tabContent && tabContent.classList.contains('active')) {
                forceTabContainerResize(tabContent);
            }

        } else {
            wrapper.style.maxHeight = collapsedH + 'px';
            wrapper.classList.remove('is-expanded');
            btn.textContent = 'Continue Reading...';
            btn.setAttribute('aria-expanded', 'false');
        }

        btn.style.display = fullHeight <= collapsedH ? 'none' : 'inline-block';
    }

    function initReadMore(container) {
        const btn = container.querySelector('.read-more-toggle');
        if (!btn || btn.dataset.rmInit === '1') {
            setCollapsedHeight(container);
            return;
        }

        btn.dataset.rmInit = '1';

        const tabId = container.closest('[data-tab-id]').dataset.tabId;
        const key = container.id || tabId || Math.random();
        setCollapsedHeight(container);

        btn.addEventListener('click', function() {
            const wrapper = container.querySelector('.read-more-wrapper');
            const content = container.querySelector('.read-more-content');
            const tabContent = container.closest('.custom__tab-text');
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';

            expandedStates.set(key, !isExpanded);

            if (isExpanded) {
                // COLLAPSE:
                if (wrapper.style.maxHeight === '' || wrapper.style.maxHeight === 'none') {
                    const start = content.scrollHeight || measureHiddenHeight(content, wrapper.clientWidth);
                    wrapper.style.maxHeight = start + 'px';
                    wrapper.offsetHeight; // force reflow
                }
                const collapsedH =
                    wrapper.dataset.collapsedHeight ||
                    Math.ceil(parseFloat(getComputedStyle(content).fontSize || 16) * 1.2 * 3);
                wrapper.style.maxHeight = collapsedH + 'px';
                wrapper.classList.remove('is-expanded');

                btn.textContent = 'Continue Reading...';
                btn.setAttribute('aria-expanded', 'false');

                // Force parent resize immediately after starting the collapse transition
                if (tabContent) {
                    forceTabContainerResize(tabContent);
                }

            } else {
                // EXPAND:
                let fullHeight = content.scrollHeight;
                if (!fullHeight || fullHeight < 1) {
                    fullHeight = measureHiddenHeight(content, wrapper.clientWidth);
                }
                wrapper.style.maxHeight = fullHeight + 'px';
                wrapper.classList.add('is-expanded');

                const onTransitionEnd = function(e) {
                    if (e.target !== wrapper || e.propertyName !== 'max-height') return;
                    if (btn.getAttribute('aria-expanded') === 'true') {
                        wrapper.style.maxHeight = 'none';
                    }
                    // Force parent resize after transition completes AND max-height is 'none'
                    if (tabContent) {
                        forceTabContainerResize(tabContent);
                    }
                    wrapper.removeEventListener('transitionend', onTransitionEnd);
                };
                wrapper.addEventListener('transitionend', onTransitionEnd);

                // **NEW FALLBACK FIX**: Use a short timeout to set max-height to none AND force parent resize
                // This ensures the height change is registered even if transition events are missed.
                setTimeout(() => {
                    if (btn.getAttribute('aria-expanded') === 'true') {
                        wrapper.style.maxHeight = 'none';
                        if (tabContent) {
                            forceTabContainerResize(tabContent);
                        }
                    }
                }, 450); // Slightly longer than transition time (0.38s)


                btn.textContent = 'Show Less';
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    }

    function refreshAll() {
        document.querySelectorAll('.read-more-container').forEach(setCollapsedHeight);
    }

    function initAll() {
        document.querySelectorAll('.read-more-container').forEach(initReadMore);
    }

    initAll();

    window.addEventListener('resize', () => {
        clearTimeout(window.__readmore_resize_timeout);
        window.__readmore_resize_timeout = setTimeout(refreshAll, 200);
    });

    // --- FIX: Recalculate and force parent height on tab switch ---
    document.querySelectorAll('[data-tabs-title]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetTabId = btn.dataset.tab.replace('#', '');

            // Delay to allow the tab content to become visible (CSS 'display: block' applied)
            setTimeout(() => {
                const activeTabContent = document.getElementById(targetTabId);
                if (activeTabContent) {
                    // Re-apply state and recalculate height
                    activeTabContent.querySelectorAll('.read-more-container').forEach(setCollapsedHeight);

                    // **CRITICAL FIX**: Force the tab's parent wrapper to re-measure height
                    forceTabContainerResize(activeTabContent);

                }
            }, 50);
        });
    });
});